import { useLayoutEffect } from "react";
import { applySeo, type SeoInput } from "@/lib/seo";

/**
 * Applies a route's document-head tags for as long as the component is mounted.
 *
 * The dependency list is the serialised input rather than the object itself:
 * callers pass an inline literal, which is a fresh reference on every render and
 * would otherwise re-run the effect (and rebuild the JSON-LD script tags) on
 * every state change in the page.
 */
export function useSeo(input: SeoInput) {
  const key = JSON.stringify(input);
  useLayoutEffect(() => {
    return applySeo(JSON.parse(key) as SeoInput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
